import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { useTranslation } from "@coworker/locales";
import { useCallback, useMemo, useState } from "react";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { ItemWithPieces } from "@coworker/apprestructured/src/shared/types/item";
import ImagePreviewAddOn from "../TaskCreatorAndEditorSheet/ListItem/ImagePreviewAddOn/ImagePreviewAddOn";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./MultipleArticles.module.css";
import {
  isLoading,
  LOADING,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";
import { ItemCardWithPieces } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardWithPieces/ItemCardWithPieces";

type MultipleArticlesProps = {
  articles: ItemWithPieces[] | Loading;
};

function MultipleArticles({ articles }: MultipleArticlesProps) {
  const [showModal, setShowModal] = useState(false);

  const { t } = useTranslation();

  const handleOpenModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const title = useMemo(() => {
    if (isLoading(articles)) {
      return LOADING;
    } else if (articles.length === 1) {
      return `1 ${t("articleString")}`;
    } else {
      return `${articles.length} ${t("articlesString")}`;
    }
  }, [articles, t]);

  return (
    <>
      <button
        className={styles["card"]}
        onClick={isLoading(articles) ? undefined : handleOpenModal}
      >
        <div className={styles["articles"]}>
          <FixaText textStyle="Heading.S" className={styles["title"]}>
            {isLoading(title) ? <>&nbsp;</> : title}
          </FixaText>
          <ImagePreviewAddOn
            srcs={
              isLoading(articles)
                ? LOADING
                : articles.map((article) => article.smallImageUrl || "")
            }
          />
        </div>
      </button>
      <FixaModal
        visible={showModal}
        handleCloseBtn={handleCloseModal}
        data-testid="MultipleArticles-FixaModal"
      >
        <FixaSheets
          labelledById="task-management-multiple-articles-header"
          header={
            isLoading(articles) ? null : (
              <FixaModalHeader
                id="task-management-multiple-articles-header"
                title={isLoading(title) ? "" : title}
                closeBtnClick={handleCloseModal}
              />
            )
          }
          footer={
            <FixaModalFooter renderBorder>
              <FixaButton
                type="primary"
                fluid
                text={t("doneString")}
                onClick={handleCloseModal}
              />
            </FixaModalFooter>
          }
          fullSize
        >
          <FixaModalBody>
            {isLoading(articles)
              ? null
              : articles.map((article) => (
                  <div className={styles["articleCard"]} key={article.no}>
                    <ItemCardWithPieces item={article} />
                  </div>
                ))}
          </FixaModalBody>
        </FixaSheets>
      </FixaModal>
    </>
  );
}

export default MultipleArticles;
